import React from "react";
import styled from "styled-components";
import { Typography, Dialog } from "@material-ui/core";
import parse from "html-react-parser";
import { Image } from "../../atoms";
import { makeStyles } from "@material-ui/core/styles";

type ModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  title: string;
  subtitle?: string;
  photo: string;
  content: string;
  widthImg?: number | undefined;
};

const StyledContainer = styled.div`
  margin: 2rem;
  display: flex;
  max-height: 500px;
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

type StyledImageProps = {
  widthImg: number | undefined;
};

const StyledImage = styled.div<StyledImageProps>`
  width: ${({ widthImg }) => widthImg || 300}px;
  margin-right: 2rem;
  @media screen and (max-width: 600px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 2rem;
  }
`;

const StyledContent = styled.div`
  flex: 1;
  max-width: 500px;
`;

const StyledBorder = styled.div`
  margin: 1rem 0;
  border-bottom: 1px solid #e3232a;
`;

const useStyles = makeStyles((theme) => ({
  rootDialog: {
    "& .MuiDialog-paperWidthMd": {
      width: "100%",
    },
  },
  iconButtonRoot: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
  },
}));

const Modal = ({
  isOpen,
  onRequestClose,
  title,
  subtitle,
  photo,
  content,
  widthImg,
}: ModalProps) => {
  const classes = useStyles();
  return (
    <Dialog
      className={classes.rootDialog}
      maxWidth="md"
      onClose={onRequestClose}
      aria-labelledby="simple-dialog-title"
      open={isOpen}
    >
      <StyledContainer>
        <StyledImage widthImg={widthImg}>
          <Image height={400} src={photo} redLine={true} />
        </StyledImage>
        <StyledContent>
          <Typography variant="h5" color="textPrimary">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="h6" color="textSecondary">
              {subtitle}
            </Typography>
          )}
          <StyledBorder />
          <div id="content">{parse(content)}</div>
        </StyledContent>
      </StyledContainer>
    </Dialog>
  );
};

export default Modal;
